import { URN } from "@sharedcommon/model/urn.model";
import { RawmaterialOrSampleStatus } from "@sharedcommon/util/rawmaterial-or-sample-status.utils";
import { CalculationStatus } from "@sharedcommon/model/calculation-status.model";
import { SampleFarmDto } from "./sample-farm.model";
import { SpeciesDto } from "./species.model";
import { AnalysisOriginDto } from "./analysis-origin.model";
import { SampleProductDto } from "./sample-product.model";
import { SampleCustomerDto } from "./sample-customer.model";
import { SampleSupplierDto } from "./sample-supplier.model";
import { ImportType } from "@sharedcommon/model/import-type.model";
import { SampleDocumentDto } from "./sample-document.model";

export class SampleDto {
  id: string;
  activity: URN;
  entity: URN;
  supplierUrn: URN;
  code: string;
  label: string;
  tag: string;
  originalBusinessUnit: URN;
  reference: URN;
  notes: string;
  lockUserFullName: string;
  lockUserBy: string;
  lockDate: Date;
  archivedBy: string;
  disabledBy: string;
  calculationBy: string;
  calculationDate: Date;
  calculationStatus: CalculationStatus;
  exportBy: string;
  exportDate: Date;
  requester: string;
  version: number;
  contractCode: string;
  variety: string;
  plot: string;
  silo: string;
  harvestDate: Date|string;
  samplingDate: Date|string;
  validationDate: Date|string;
  technicianObservation: string;
  receptionDate: Date|string;
  approvedBy: string;
  excludeFromTheStats: boolean;
  chopCode: string;
  chop: string;
  rawWeight: number;
  structure: string;
  subStructure: string;
  orderNumber: string;
  technicianName: string;
  status: RawmaterialOrSampleStatus;
  originalImportType: ImportType;
  forcedCalcStatus: boolean;

  species: SpeciesDto;
  analysisOrigin: AnalysisOriginDto;
  farm: SampleFarmDto;
  product: SampleProductDto;
  customer: SampleCustomerDto;
  supplier: SampleSupplierDto;

  documents:SampleDocumentDto[];
  inputs: any[];

  creationDate: Date|string;
  createdBy: string;
  modificationDate: Date|string;
  modifiedBy: string;
}
